import { call, put } from 'redux-saga/effects';
import { ActionTypes } from 'constants/index';
import { showAlert, getLocationImport, getLocationImports } from 'actions/index';

export function* getLocationImportsSaga(api, action) {
  const response = yield call(api.getLocationImports, action.payload);
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.GET_LOCATION_IMPORTS_SUCCESS,
      payload: data,
    });
  } else {
    yield put({ type: ActionTypes.GET_LOCATION_IMPORTS_FAILURE });
    if (status !== 500 && status !== 401) {
      yield put(showAlert(data.errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* getLocationImportSaga(api, action) {
  const { id, params } = action.payload;
  const response = yield call(api.getLocationImport, id, params);
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.GET_LOCATION_IMPORT_SUCCESS,
      payload: data,
    });
  } else {
    yield put({ type: ActionTypes.GET_LOCATION_IMPORT_FAILURE });
    if (status !== 500 && status !== 401) {
      yield put(showAlert(data.errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* uploadLocationImportSaga(api, action) {
  const formData = new FormData();
  formData.append('file', action.payload.file);

  const response = yield call(api.uploadLocationImport, formData);
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.UPLOAD_LOCATION_IMPORT_SUCCESS,
      payload: data,
    });
    yield put(
      showAlert('Import staged. Review pending rows before approval.', { variant: 'success' }),
    );
    yield put(getLocationImports());
    if (data && data.import && data.import.id) {
      yield put(getLocationImport(data.import.id));
    }
  } else {
    yield put({ type: ActionTypes.UPLOAD_LOCATION_IMPORT_FAILURE });
    if (status !== 500 && status !== 401) {
      yield put(showAlert(data.errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* updateLocationImportRowSaga(api, action) {
  const { importId, rowId, row } = action.payload;
  const response = yield call(api.updateLocationImportRow, importId, rowId, row);
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.UPDATE_LOCATION_IMPORT_ROW_SUCCESS,
      payload: data,
    });
    yield put(showAlert('Import row saved', { variant: 'success' }));
    yield put(getLocationImport(importId));
    yield put(getLocationImports());
  } else {
    yield put({ type: ActionTypes.UPDATE_LOCATION_IMPORT_ROW_FAILURE });
    if (status !== 500 && status !== 401) {
      yield put(showAlert(data.errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* approveLocationImportSaga(api, action) {
  const { importId, payload } = action.payload;
  const response = yield call(api.approveLocationImport, importId, payload);
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.APPROVE_LOCATION_IMPORT_SUCCESS,
      payload: data,
    });

    const approvedCount = data.results && data.results.approved ? data.results.approved.length : 0;
    const failedCount = data.results && data.results.failed ? data.results.failed.length : 0;
    yield put(
      showAlert(`Approval complete: ${approvedCount} approved, ${failedCount} failed`, {
        variant: failedCount ? 'warning' : 'success',
        timeout: 9,
      }),
    );
    yield put(getLocationImport(importId));
    yield put(getLocationImports());
  } else {
    yield put({ type: ActionTypes.APPROVE_LOCATION_IMPORT_FAILURE });
    if (status !== 500 && status !== 401) {
      yield put(showAlert(data.errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* deleteLocationImportSaga(api, action) {
  const { id } = action.payload;
  const response = yield call(api.deleteLocationImport, id);
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.DELETE_LOCATION_IMPORT_SUCCESS,
      payload: { deletedId: id },
    });
    yield put(showAlert('Import deleted', { variant: 'success' }));
    yield put(getLocationImports());
  } else {
    yield put({ type: ActionTypes.DELETE_LOCATION_IMPORT_FAILURE });
    if (status !== 500 && status !== 401) {
      yield put(
        showAlert(data?.errors?.message || 'Delete failed', { variant: 'danger', timeout: 9 }),
      );
    }
  }
}
